import React from "react";
import { connect } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import AlertModalAction from "../../redux/actions/AlertModalAction";

const AlertModal = (props) => {
  const closeModal = () => {
    AlertModalAction.reset().then(AlertModalAction.onClose);
  };

  return (
    <Modal
      open={props.data.open}
      onClose={closeModal}
      size="tiny"
      centered={false}
    >
      <Modal.Header>{props.data.title}</Modal.Header>
      <Modal.Content
        content={props.data.message.split("\n").map((x, idx) => {
          return (
            <span key={idx}>
              {x}
              <br />
            </span>
          );
        })}
      />
      <Modal.Actions>
        <Button onClick={closeModal} color="green">
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    data: AlertModalAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(AlertModal);
